import { post } from 'api';
import { GetMetricsRequest } from './types';

export const getMetrics = (payload: GetMetricsRequest) =>
  post({
    data: payload,
    url: `/metrics`,
  });
